/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Totals_TimeInputs */

const en_us2_progress_totals_time = /** @type {(inputs: Progress_Totals_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time this month`)
};

const pt_br2_progress_totals_time = /** @type {(inputs: Progress_Totals_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo no mês`)
};

const es_419_progress_totals_time = /** @type {(inputs: Progress_Totals_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo del mes`)
};

const pt_pt2_progress_totals_time = /** @type {(inputs: Progress_Totals_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo no mês`)
};

const fr_fr2_progress_totals_time = /** @type {(inputs: Progress_Totals_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps ce mois-ci`)
};

const de_de2_progress_totals_time = /** @type {(inputs: Progress_Totals_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit diesen Monat`)
};

const it_it2_progress_totals_time = /** @type {(inputs: Progress_Totals_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo nel mese`)
};

/**
* | output |
* | --- |
* | "Time this month" |
*
* @param {Progress_Totals_TimeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_totals_time = /** @type {((inputs?: Progress_Totals_TimeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Totals_TimeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_totals_time(inputs)
	if (locale === "es-419") return es_419_progress_totals_time(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_totals_time(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_totals_time(inputs)
	if (locale === "de-DE") return de_de2_progress_totals_time(inputs)
	if (locale === "it-IT") return it_it2_progress_totals_time(inputs)
	return en_us2_progress_totals_time(inputs)
});
export { progress_totals_time as "progress.totals_time" }